<template>
  <v-container class="pa-0 ma-0">
    <v-row>
      <v-col>
        <v-autocomplete
          :items="languages"
          v-model="form.language"
          :label="$tc('texts.language.label', 1)"
          item-text="name"
          item-value="key"
          required
          :error-messages="errors.collect('userSettings.language')"
          v-validate="'required'"
          data-vv-name="userSettings.language"
          :data-vv-as="$tc('texts.language.label', 1)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox
          v-model="form.newsletter"
          :label="$t('texts.acceptAdvertising')"
          :true-value="true"
          :false-value="false"
          color="primary"
          hide-details
          class="mt-0"
        >
        </v-checkbox>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
    },
  },
  data() {
    return {
      languages: [
        { key: 'de', name: 'Deutsch' },
        { key: 'it', name: 'Italiano' },
        { key: 'en', name: 'English' },
      ],
    };
  },
};
</script>
